export const VIDEO_CALL_INVITATION_CODE_ALPHABET = "bcdfghjklmnpqrstvwxyz";
export const VIDEO_CALL_INVITATION_CODE_PATTERN_SOURCE = `[${VIDEO_CALL_INVITATION_CODE_ALPHABET}]{5}(?:-[${VIDEO_CALL_INVITATION_CODE_ALPHABET}]{5}){2}`;

const VIDEO_CALL_INVITATION_CODE_PATTERN = new RegExp(
  `^${VIDEO_CALL_INVITATION_CODE_PATTERN_SOURCE}$`,
);
const VIDEO_CALL_INVITATION_PATH_PATTERN = new RegExp(
  `^/v/(${VIDEO_CALL_INVITATION_CODE_PATTERN_SOURCE})$`,
);
const VIDEO_CALL_SHORT_ROUTE_PATTERN = /^\/v(?:\/|$)/;

export const isVideoCallInvitationCode = (value: string): boolean =>
  VIDEO_CALL_INVITATION_CODE_PATTERN.test(value);

export const isVideoCallShortRoutePath = (path: string): boolean => {
  const [pathname] = path.split(/[?#]/, 1);
  return VIDEO_CALL_SHORT_ROUTE_PATTERN.test(pathname);
};

export const getVideoCallInvitationCodeFromPath = (
  path: string,
): string | null => {
  const [pathname] = path.split(/[?#]/, 1);
  return VIDEO_CALL_INVITATION_PATH_PATTERN.exec(pathname)?.[1] ?? null;
};

export const buildVideoCallShareUrl = ({
  token,
  origin,
  shareUrl,
}: {
  token: string;
  origin: string;
  shareUrl?: string;
}): string => {
  if (shareUrl) {
    return shareUrl;
  }

  const normalizedOrigin = origin.replace(/\/+$/u, "");
  if (isVideoCallInvitationCode(token)) {
    return `${normalizedOrigin}/v/${token}`;
  }

  return `${normalizedOrigin}/video-call#token=${encodeURIComponent(token)}`;
};

const VIDEO_CALL_SHARE_URL_REFERENCE_PATTERN = new RegExp(
  `(?:^|[^A-Za-z0-9_./-])(?:https?:\\/\\/[^\\s/?#]+)?\\/v\\/${VIDEO_CALL_INVITATION_CODE_PATTERN_SOURCE}(?![A-Za-z0-9_%~\\/-])`,
);

export const containsVideoCallShareUrlReference = (value: string): boolean =>
  VIDEO_CALL_SHARE_URL_REFERENCE_PATTERN.test(value);
